import useUserAndToken from '../../../../core/useUserAndToken';
import { usePwaClientTracking } from '../hooks/usePwaClientTracking';

/**
 * Mount inside the authenticated app shell (next to PwaInstallTracking).
 * Renders nothing — it only keeps user.last_client / last_pwa_open_at current.
 */
export function PwaClientTracking() {
    const { user, token } = useUserAndToken();
    usePwaClientTracking({ user, token });

    return null;
}

export default PwaClientTracking;
